var render = function render(){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"u-mar-b9"},_vm._l((_vm.items),function(options,index){return _c('span',[_c('BaseChip',{attrs:{"iconSelected":_vm.iconSelected,"iconPosition":_vm.iconPosition,"isSelected":options.Selected,"value":options.Value},on:{"click":function($event){}}})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }